<template>
  <iframe :src="webUrl+'/admin/platform/yjfk'"></iframe>
</template>

<script>
export default {
  name: "suggestion",
  setup(){
    return {
      "webUrl" : process.env.VUE_APP_DAILIAO_WEB_URL
    }
  }
}
</script>

<style scoped>

</style>